import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Bindings to types defined in PerformanceArchive/Models/SearchResults.cs
type GenericSearchResult =
	| SearchResult
	| SearchByResult;

export type SearchResult = {
	operaId: number;
	presentationCount: number;
	composerName: string;
	operaTitle: string;
	operaSortTitle: string;
	detailPageUrl: string;
}

export type SearchByResult = SearchResult & {
	castResults: CastResult[];
}

export type SearchResults = {
	results: GenericSearchResult[];
	totalResultCount: number;
	errorMessage: string;
	innerException: string;
	maintenanceMode: boolean;
}

type CastResult = {
	season: string;
	roleTitle: string;
	roleSortTitle: string;
	artistFullName: string;
	order: number;
	debut: boolean;
}

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: '/api/archive/Search/',
    }),
    keepUnusedDataFor: 0,
    endpoints: (builder) => ({
        fetchResults: builder.query<SearchResults, any>({
            query: ({ searchBy, term, sortBy }) =>
                `/?pageSize=1000&pageIndex=0&searchBy=${searchBy}&term=${term}&sortBy=${sortBy}`,
        }),
    }),
});

export const { useFetchResultsQuery } = apiSlice;